export { ObjectDetailActions } from "./Actions";
export { ObjectDetailAmenities } from "./Amenities";
export { ObjectDetailCharacteristics } from "./Characteristics";
export { ObjectDetailDescription } from "./Description";
export { ObjectDetailDeveloper } from "./Developer";
export { ObjectDetailHeader } from "./Header";
export { ObjectDetailLayouts } from "./Layouts";
export { ObjectDetailManagerInfo } from "./ManagerInfo";
export { ObjectDetailMeta } from "./Meta";
export { ObjectDetailPricing } from "./Pricing";
export { ObjectDetailSlider } from "./Slider";
export { ObjectDetailUtilities } from "./Utilities";
